import React from 'react';
import toastr from 'toastr';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Line,Card,Column,Panel} from 'ktm-ui';

interface IdsBenefit {
    Id:string;
    Policy_Id:string;
    HSAAdminRate:number;
    HSAMinAdminFee:number;
    HSAMaxAdminFee:number;
    CarryFwdHSA:string;
};

export default KTMScreen({name:"planadmin.product.edit-hsa"}, class extends React.Component<{policyBenefit_id:string}> {

    data:{
        dsBenefit:IdsBenefit;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsBenefit";
        await KTMApi.start(screen,{
            "@policyBenefit_id":this.props.policyBenefit_id,
        });
        screen.title = "Edit HSA Details";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Edit HSA Details"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary"/>
            </Dialog.Footer>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Line>
                    <Display required field={field("HSAAdminRate")}/>
                    <Display required field={field("HSAMinAdminFee")}/>
                    <Display required field={field("HSAMaxAdminFee")}/>
                </Line>
                <Display required field={field("CarryFwdHSA")}/>
            </Card>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    {draw(this.details)}
                </Column>
            </Panel>
        );
    }

    async submit({screen}:ActionEvent){
        // Guardrail: block obviously wrong admin fees; warn on unusual ones.
        // Typical real-world HSA admin rate is 5–12%; 100% caused the Wild Wapiti incident.
        const rate = Number(this.data.dsBenefit.HSAAdminRate);
        if (rate > 50){
            toastr.error(`HSA Admin Rate of ${rate}% exceeds the 50% maximum. Please correct before saving.`);
            return;
        }
        if (rate > 15){
            try {
                await screen.showWarning({
                    message: `HSA Admin Rate of ${rate}% is higher than typical (5–12%). Are you sure you want to save?`,
                });
            } catch {
                return;
            }
        }
        await KTMApi.action(screen,"submit",{
            "@dsBenefit.HSAAdminRate":this.data.dsBenefit.HSAAdminRate,
            "@dsBenefit.HSAMinAdminFee":this.data.dsBenefit.HSAMinAdminFee,
            "@dsBenefit.HSAMaxAdminFee":this.data.dsBenefit.HSAMaxAdminFee,
            "@dsBenefit.CarryFwdHSA":this.data.dsBenefit.CarryFwdHSA,
            "@policyBenefit_id":this.props.policyBenefit_id,
        });
        screen.close({"continue":true});
    }

});
